import { useState } from "react";

const faqData = [
  {
    question: "Is de prijs maandelijks? Word ik opnieuw gefactureerd?",
    answer:
      "Nee, het is een eenmalige betaling. Wij rekenen geen maandelijkse kosten en verlengen je abonnement niet automatisch. Je betaalt één keer en krijgt toegang voor de gekozen periode.",
  },
  {
    question: "Hoe ontvang ik mijn inloggegevens na aankoop?",
    answer:
      "Na het afronden van je bestelling worden je inloggegevens (M3U-link, Xtream Codes-gebruikersnaam en wachtwoord) binnen enkele minuten naar je e-mailadres en via WhatsApp verzonden. Controleer ook je spammap.",
  },
  {
    question: "Kan ik IPTV gebruiken als ik in een appartement woon?",
    answer:
      "Ja, IPTV is perfect voor bewoners van appartementen. Er is geen schotelantenne of ingewikkelde installatie nodig. Je hebt alleen een internetverbinding en een compatibel apparaat nodig (Smart TV, TV Box, smartphone, tablet, computer, enz.).",
  },
  {
    question: "Op hoeveel apparaten kan ik tegelijkertijd kijken?",
    answer:
      "Dat hangt af van het gekozen pakket. De standaardpakketten ondersteunen 1 tot 2 gelijktijdige schermen. Onze Multi-Screen pakketten bieden 2, 3 of 4 gelijktijdige verbindingen.",
  },
  {
    question: "Waarom word ik doorgestuurd naar een andere site om af te rekenen?",
    answer:
      "Voor een veilige transactie word je doorgestuurd naar de betaalpagina van onze vertrouwde partner. Zodra je bestelling is afgerond, ontvang je je activeringsgegevens per e-mail en WhatsApp.",
  },
  {
    question: "Heb ik een schotelantenne nodig om feesttv te gebruiken?",
    answer:
      "Nee, je maakt via internet verbinding met onze servers. Je hebt geen schotel of satellietapparatuur nodig — alleen een stabiele internetverbinding.",
  },
  {
    question: "Wat zijn de minimale vereisten voor de internetsnelheid?",
    answer:
      "Voor HD-kwaliteit raden we een stabiele internetverbinding van minstens 10 Mbps aan. Voor 4K Ultra HD is een snelheid van minstens 25 Mbps aanbevolen.",
  },
  {
    question: "Zijn er volwassenenkanalen inbegrepen en hoe beveilig ik ze?",
    answer:
      "Ja, optionele volwassenenkanalen en VOD zijn inbegrepen. Deze zijn standaard beveiligd met een pincode, zodat ze veilig verborgen blijven voor kinderen.",
  },
  {
    question: "Wat als ik hulp nodig heb bij de installatie?",
    answer:
      "Ons ondersteuningsteam is 24/7 beschikbaar via WhatsApp en e-mail om je stap voor stap te begeleiden bij de installatie op elk type apparaat.",
  },
  {
    question: "Bieden jullie een geld-terug-garantie?",
    answer:
      "Ja, we bieden een geld-terug-garantie van 15 dagen. Als je niet tevreden bent met onze service, kun je binnen 15 dagen een volledige terugbetaling aanvragen.",
  },
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqData.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: { "@type": "Answer", text: item.answer },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState({ 0: true });

  const toggle = (index) => {
    setOpen((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section className="py-12 sm:py-16 bg-slate-50" id="faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mx-auto font-black mb-3 sm:mb-4 max-w-3xl leading-snug text-center">
            Veelgestelde{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
              Vragen
            </span>
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto font-medium">
            Vind antwoorden op de meest gestelde vragen over feesttv
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 max-w-full mx-auto">
          {faqData.map((item, index) => {
            const isOpen = !!open[index];
            return (
              <div
                key={index}
                onClick={() => toggle(index)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggle(index);
                  }
                }}
                className="bg-white rounded-lg shadow-md p-4 sm:p-6 cursor-pointer transition-all duration-300 hover:shadow-lg self-start"
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-bold text-slate-900 text-sm sm:text-base lg:text-lg pr-3 sm:pr-4 leading-tight">
                    {item.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <span className="inline-flex w-5 h-5 sm:w-6 sm:h-6 items-center justify-center text-[#090979] text-xl sm:text-2xl font-bold leading-none">
                      {isOpen ? "−" : "+"}
                    </span>
                  </div>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="text-slate-700 mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-slate-200 leading-relaxed text-sm sm:text-base">
                    {item.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
